import { fetchConfig as doFetchConfig } from '@store/config/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useConfig = () => {
  const config = useSelector((state) => state.config);
  const dispatch = useDispatch();

  const fetchConfig = useCallback(() => dispatch(doFetchConfig()), [dispatch]);

  return { config, fetchConfig };
};

export default useConfig;
